import styled from 'styled-components/macro';
import Form from 'components/molecules/Form';
import Link from 'components/atoms/Link';

export const StyledForm = styled(Form)`
  text-align: left;
  max-width: 100%;
  margin: 0;
`;

export const ForgotPassLink = styled(Link)`
  color: var(--primary);
  font-weight: bold;
`;
